// extracted by mini-css-extract-plugin
export default {"blurbIcon":"_b66f3328","blurbTitle":"_b66ce63","blurbDetail":"_17046f92"};